import React, { useState } from "react"
import styled from "@emotion/styled"
import * as mq from "../../styles/mediaQueries"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import { typography, util, animations, globals } from "src/styles"
import AnimatedIcon from "src/components/AnimatedIcon"
import ScrollEntrance from "src/components/ScrollEntrance"
import AnimateHeight from "react-animate-height"
import SanityRichText from "src/components/SanityRichText"

const Wrapper = styled(Section)`
  text-align: center;
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => hideMobile && "display: none"}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => hideDesktop && "display: none"}
  }
`

const FaqHeadline = styled.div`
  ${globals.verticalSpacing("padding-bottom", 0.5)}
  h3 {
    margin: 0;
  }
`

const SectionHeader = styled.div`
  ${typography.h6}
  margin-bottom: 1.1em;
  ${({ firstItem }) =>
    !firstItem
      ? `
    margin-top: 2em;
  `
      : ""}
`

const QaContent = styled(ScrollEntrance)`
  margin: 0 auto;
  width: 100%;
  border-bottom: 1px solid var(--hr-color);

  ${mq.largerAndUp} {
    max-width: 66%;
  }
`

const QaItem = styled.div`
  text-align: left;
`

const Question = styled.button`
  appearance: none;
  display: inline-block;
  width: 100%;
  text-align: inherit;
  border: none;
  outline: none;
  background: transparent;
  padding: 0;
  margin: 0;
  border-top: 1px solid var(--hr-color);
  ${typography.body}
  ${util.responsiveStyles("padding-top", 20, 16, 14, 14)}
  ${util.responsiveStyles("padding-bottom", 20, 16, 14, 14)}
  cursor: pointer;
  transition: color ${animations.mediumSpeed} ease-in-out;
  color: var(--light-text-color);
  &:hover {
    color: var(--text-color);
  }
  ${({ expanded }) =>
    expanded
      ? `
    color: var(--text-color);
  `
      : `
    color: var(--light-text-color);
  `}
  display: flex;
  justify-content: space-between;
  p {
    max-width: 36em;
    margin: 0 1em 0 0;
    color: inherit;
  }
  > div {
    flex-shrink: 0;
    margin-top: 1px;
    color: var(--main-color);
  }
`

const AnswerContent = styled.div`
  ${util.responsiveStyles("padding-bottom", 20, 16, 14, 14)}
  p, li {
    ${typography.bodySmall}
  }
`

const Faqs = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  isFirstSection,
  headingSize,
  headline,
  qaList,
  id,
  hideMobile,
  hideDesktop,
}) => {
  const [currentAnswer, setCurrentAnswer] = useState()
  const toggelAnswser = item => {
    if (item !== currentAnswer) {
      setCurrentAnswer(item)
    } else {
      setCurrentAnswer(false)
    }
  }

  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      setTheme={theme}
      nextTheme={nextTheme}
      isFirstSection={isFirstSection}
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <Grid small="m [1] m" medium="1 [12] 1">
        <QaContent>
          {headline && (
            <FaqHeadline>
              <h3 className={headingSize ? headingSize : "h3"}>
                {headline}
              </h3>
            </FaqHeadline>
          )}
          {qaList.map((item, index) => {
            if (item._type === "sectionTitle") {
              return (
                <SectionHeader firstItem={index === 0} key={item._key}>
                  {item.sectionName}
                </SectionHeader>
              )
            } else {
              return (
                <QaItem key={item._key}>
                  <Question
                    onClick={() => toggelAnswser(item._key)}
                    expanded={item._key === currentAnswer}
                  >
                    <p>{item.question}</p>
                    <AnimatedIcon
                      icon={item._key === currentAnswer ? "close" : "plus"}
                      size={18}
                    />
                  </Question>
                  <AnimateHeight
                    className={
                      item._key === currentAnswer ? "content open" : "content"
                    }
                    duration={300}
                    delay={0}
                    animateOpacity={false}
                    height={item._key !== currentAnswer ? 0 : "auto"}
                  >
                    <AnswerContent>
                      <SanityRichText text={item._rawAnswer} />
                    </AnswerContent>
                  </AnimateHeight>
                </QaItem>
              )
            }
          })}
        </QaContent>
      </Grid>
    </Wrapper>
  )
}

export default Faqs
